import Sentry from "@similarweb/sentry-logger";

import { PreferencesService } from "app/services/preferences/preferencesService";

const SECOND_LAND_EXTENSION_PROMO_SEEN_PREF_KEY = "secondLandExtensionModal.seen";
const SECOND_LAND_EXTENSION_PROMO_SESSION_GUARD_KEY = "secondLandExtensionModal.shown";

export const hasSeenSecondLandExtensionPromo = (): boolean =>
    PreferencesService.get(SECOND_LAND_EXTENSION_PROMO_SEEN_PREF_KEY) === true;

export const markSecondLandExtensionPromoSeen = (): void => {
    void PreferencesService.add({
        [SECOND_LAND_EXTENSION_PROMO_SEEN_PREF_KEY]: true,
    });
};

export const wasSecondLandExtensionPromoShownThisSession = (): boolean => {
    try {
        return sessionStorage.getItem(SECOND_LAND_EXTENSION_PROMO_SESSION_GUARD_KEY) === "true";
    } catch (error) {
        Sentry.error(
            `Failed to get value in sessionStorage (key: "${SECOND_LAND_EXTENSION_PROMO_SESSION_GUARD_KEY}"):`,
            error as Error,
        );

        return false;
    }
};

export const markSecondLandExtensionPromoShownThisSession = (): void => {
    try {
        sessionStorage.setItem(SECOND_LAND_EXTENSION_PROMO_SESSION_GUARD_KEY, "true");
    } catch (error) {
        Sentry.error(
            `Failed to set value in sessionStorage (key: "${SECOND_LAND_EXTENSION_PROMO_SESSION_GUARD_KEY}"):`,
            error as Error,
        );
        return undefined;
    }
};
